export const getStore = () => window.ApprovalMax.app.getStore();
